import { render } from "./NavBase.vue?vue&type=template&id=0ff5aba9&scoped=true"
import script from "./NavBase.vue?vue&type=script&lang=js"
export * from "./NavBase.vue?vue&type=script&lang=js"

import "./NavBase.vue?vue&type=style&index=0&id=0ff5aba9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff5aba9"]])

export default __exports__